import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { END_POINT, METHODS } from "../../../helper/helper";
import { fetchData } from "../../../helper/ApiCall";
import { useDispatch } from "react-redux";
import { userdataUpdate } from "../../../redux/reducers/userReducer";
import Swal from "sweetalert2";

const AdminLogin = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [email, setEmail] = useState("");
    const [password, setpassword] = useState("");

    const LoginHandler = async () => {
        try {
            const raw = JSON.stringify({ email, password });
            const result = await fetchData(END_POINT.UserLogin, METHODS.POST, raw);
            if (result.success == true) {
                console.log(result);
                dispatch(userdataUpdate(result.data));
                navigate("/admin/admin-dashboard");
            } else {
                Swal.fire({
                    title: "Wrong",
                    text: result.message,
                    icon: "error",
                    showCancelButton: false,
                    confirmButtonColor: "#6366f1",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Cancel",
                });
            }
        } catch (err) {
            console.log(err);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") LoginHandler();
    };

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=DM+Sans:wght@300;400;500&display=swap');

                .al-body {
                    margin: 0;
                    padding: 0;
                    min-height: 100vh;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-family: 'DM Sans', sans-serif;
                    background: #f0f4ff;
                    position: relative;
                    overflow: hidden;
                }

                .al-bg-shape {
                    position: fixed;
                    border-radius: 50%;
                    pointer-events: none;
                    z-index: 0;
                }
                .al-bg-shape-1 {
                    width: 500px; height: 500px;
                    background: radial-gradient(circle, rgba(99,102,241,0.12) 0%, transparent 70%);
                    top: -150px; right: -150px;
                }
                .al-bg-shape-2 {
                    width: 400px; height: 400px;
                    background: radial-gradient(circle, rgba(139,92,246,0.08) 0%, transparent 70%);
                    bottom: -120px; left: -120px;
                }

                .al-split {
                    display: flex;
                    width: 100%;
                    max-width: 880px;
                    min-height: 520px;
                    border-radius: 24px;
                    box-shadow: 0 20px 60px rgba(99,102,241,0.12), 0 4px 20px rgba(0,0,0,0.06);
                    overflow: hidden;
                    position: relative;
                    z-index: 1;
                    margin: 20px;
                }

                /* Left branding */
                .al-left {
                    flex: 1;
                    background: linear-gradient(145deg, #6366f1 0%, #8b5cf6 100%);
                    padding: 52px 44px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    position: relative;
                    overflow: hidden;
                }
                .al-left::before {
                    content: '';
                    position: absolute;
                    width: 280px; height: 280px;
                    border-radius: 50%;
                    background: rgba(255,255,255,0.07);
                    top: -80px; right: -80px;
                }
                .al-left::after {
                    content: '';
                    position: absolute;
                    width: 180px; height: 180px;
                    border-radius: 50%;
                    background: rgba(255,255,255,0.05);
                    bottom: -50px; left: -40px;
                }

                .al-logo {
                    font-family: 'Syne', sans-serif;
                    font-size: 2rem;
                    font-weight: 800;
                    color: #fff;
                    letter-spacing: -0.5px;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    z-index: 1;
                }
                .al-logo span { color: rgba(255,255,255,0.55); }
                .al-logo-dot {
                    width: 8px; height: 8px;
                    border-radius: 50%;
                    background: #fff;
                    margin-left: 3px;
                    animation: al-pulse 2s ease-in-out infinite;
                }
                @keyframes al-pulse {
                    0%, 100% { opacity: 1; }
                    50% { opacity: 0.35; }
                }

                .al-left-bottom { z-index: 1; }
                .al-left-tagline {
                    font-family: 'Syne', sans-serif;
                    font-size: 1.55rem;
                    font-weight: 700;
                    color: #fff;
                    line-height: 1.35;
                    margin-bottom: 12px;
                }
                .al-left-sub {
                    font-size: 14px;
                    color: rgba(255,255,255,0.6);
                    line-height: 1.7;
                }

                /* Right form */
                .al-right {
                    flex: 1;
                    background: #ffffff;
                    padding: 52px 44px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }

                .al-form-title {
                    font-family: 'Syne', sans-serif;
                    font-size: 1.5rem;
                    font-weight: 700;
                    color: #1e1b4b;
                    margin: 0 0 6px 0;
                }
                .al-form-sub {
                    font-size: 14px;
                    color: #94a3b8;
                    margin: 0 0 32px 0;
                }

                .al-input-group { margin-bottom: 18px; }
                .al-label {
                    display: block;
                    font-size: 13px;
                    font-weight: 500;
                    color: #475569;
                    margin-bottom: 7px;
                }
                .al-input {
                    width: 100%;
                    padding: 12px 16px;
                    background: #f8faff;
                    border: 1.5px solid #e2e8f0;
                    border-radius: 10px;
                    color: #1e293b;
                    font-family: 'DM Sans', sans-serif;
                    font-size: 15px;
                    outline: none;
                    transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
                    box-sizing: border-box;
                }
                .al-input::placeholder { color: #cbd5e1; }
                .al-input:focus {
                    border-color: #6366f1;
                    background: #fff;
                    box-shadow: 0 0 0 3px rgba(99,102,241,0.1);
                }

                .al-btn {
                    width: 100%;
                    padding: 13px;
                    margin-top: 6px;
                    background: linear-gradient(135deg, #6366f1, #8b5cf6);
                    color: #fff;
                    font-family: 'Syne', sans-serif;
                    font-size: 15px;
                    font-weight: 700;
                    border: none;
                    border-radius: 10px;
                    cursor: pointer;
                    transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s;
                    box-shadow: 0 6px 20px rgba(99,102,241,0.28);
                    letter-spacing: 0.3px;
                }
                .al-btn:hover {
                    opacity: 0.92;
                    transform: translateY(-1px);
                    box-shadow: 0 10px 28px rgba(99,102,241,0.38);
                }
                .al-btn:active { transform: translateY(0); }

                .al-footer {
                    margin-top: 28px;
                    padding-top: 20px;
                    border-top: 1px solid #f1f5f9;
                    text-align: center;
                    font-size: 12px;
                    color: #cbd5e1;
                }

                @media (max-width: 640px) {
                    .al-split { flex-direction: column; border-radius: 16px; margin: 16px; }
                    .al-left { padding: 36px 28px; min-height: auto; }
                    .al-left::before, .al-left::after { display: none; }
                    .al-left-tagline { font-size: 1.2rem; }
                    .al-right { padding: 36px 28px; }
                }
            `}</style>

            <div className="al-body">
                <div className="al-bg-shape al-bg-shape-1" />
                <div className="al-bg-shape al-bg-shape-2" />

                <div className="al-split">
                    {/* Left */}
                    <div className="al-left">
                        <div className="al-logo">
                            AI<span>Hub</span>
                            <div className="al-logo-dot" />
                        </div>
                        <div className="al-left-bottom">
                            <div className="al-left-tagline">Your AI tools,<br />all in one place.</div>
                            <div className="al-left-sub">Manage your directory, update tools,<br />and track the latest AI features.</div>
                        </div>
                    </div>

                    {/* Right */}
                    <div className="al-right">
                        <h2 className="al-form-title">Welcome back 👋</h2>
                        <p className="al-form-sub">Sign in to the admin panel</p>

                        <div className="al-input-group">
                            <label className="al-label">Email address</label>
                            <input
                                type="text"
                                className="al-input"
                                placeholder="admin@example.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                onKeyDown={handleKeyDown}
                            />
                        </div>

                        <div className="al-input-group">
                            <label className="al-label">Password</label>
                            <input
                                type="password"
                                className="al-input"
                                placeholder="••••••••"
                                value={password}
                                onChange={(e) => setpassword(e.target.value)}
                                onKeyDown={handleKeyDown}
                            />
                        </div>

                        <button className="al-btn" onClick={LoginHandler}>
                            Sign In →
                        </button>

                        <div className="al-footer">AIHub Admin · Restricted Access</div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminLogin;